var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTether(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tether (USDT)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tether (USDT)_2",
    d: "M47.2766 30.3057C44.0712 43.163 31.0489 50.9877 18.1901 47.7815C5.33667 44.5761 -2.48802 31.553 0.718765 18.6967C3.92273 5.83806 16.9451 -1.98721 29.7999 1.21816C42.6577 4.42354 50.4819 17.4481 47.2762 30.306L47.2765 30.3057H47.2766Z",
    fill: "#50AF95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tether (USDT)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0368 27.2209C26.8671 27.2336 25.9903 27.2859 24.0345 27.2859C22.4789 27.2859 21.3745 27.2393 20.987 27.2209C14.9753 26.9564 10.4881 25.9099 10.4881 24.657C10.4881 23.404 14.9753 22.3589 20.987 22.0902V26.1786C21.3801 26.2069 22.5058 26.2734 24.0614 26.2734C25.9281 26.2734 26.8629 26.1956 27.0312 26.1801V22.0931C33.0301 22.3604 37.5074 23.4068 37.5074 24.657C37.5074 25.9071 33.0316 26.9536 27.0312 27.2195L27.0368 27.2209ZM27.0368 21.6702V18.0117H35.4088V12.4328H12.615V18.0117H20.9856V21.6688C14.1819 21.9813 9.06543 23.3291 9.06543 24.9441C9.06543 26.5591 14.1819 27.9054 20.9856 28.2193V39.9429H27.0354V28.2151C33.8235 27.9025 38.9315 26.5562 38.9315 24.9426C38.9315 23.3291 33.8277 21.9828 27.0354 21.6688L27.0368 21.6702Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTether);
export default __webpack_public_path__ + "static/media/Tether.b2d03c05ee70f825c92d0db3b446546b.svg";
export { ForwardRef as ReactComponent };